import { render, staticRenderFns } from "./LegoModalLayout.vue?vue&type=template&id=7a61b6bd&scoped=true"
import script from "./LegoModalLayout.vue?vue&type=script&lang=js"
export * from "./LegoModalLayout.vue?vue&type=script&lang=js"
import style0 from "./LegoModalLayout.vue?vue&type=style&index=0&id=7a61b6bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a61b6bd",
  null
  
)

export default component.exports